import { Button, ButtonHierarchies } from '@clockout-dev/design-elements';
import { ArrowLeftOutlined } from '@ant-design/icons';

function GoBackButton({ label, onClick }) {
    return (
        <Button
            type="button"
            hierarchy={ButtonHierarchies.LINK_COLOR}
            icon={<ArrowLeftOutlined />}
            onClick={onClick}
        >
            {label}
        </Button>
    )
}
export default GoBackButton;